import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEFAULT_PLAYER_CONFIG } from "@tv4/avod-web-player-common";
import { isMobile } from "@tv4/avod-web-player-device-capabilities";
import styled from "styled-components";
import GoToLiveArrow from "../icons/goToLiveArrow.svg";
import { useControls, usePlayerState } from "../providers/CoreProvider";
import { useLayoutSize } from "../providers/LayoutProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { StartOverButtons } from "../styles";
import { LayoutSize } from "../util/device";
const Button = styled.button `
  ${StartOverButtons}
  opacity: ${({ $opacity }) => $opacity};
  svg {
    margin-left: 5px;
  }
`;
const GoToLiveButton = () => {
    const translations = useTranslations();
    const controls = useControls();
    const { currentTime, duration } = usePlayerState();
    const layoutSize = useLayoutSize();
    const useShortText = !isMobile() && [LayoutSize.SMALL, LayoutSize.SMALLEST].includes(layoutSize);
    const buttonText = translations(useShortText ? "start_over__watch_live_shortened" : "start_over__watch_live");
    const isAtLiveEdge = duration - currentTime < DEFAULT_PLAYER_CONFIG.liveEdgeThreshold;
    const handleGoToLiveClick = () => {
        controls?.seekToLive?.();
    };
    return (_jsxs(Button, { "aria-label": translations("player__a11y__voice_over_go_to_live"), "aria-keyshortcuts": "End", onClick: handleGoToLiveClick, "$opacity": isAtLiveEdge ? 0.5 : 1, children: [_jsx("span", { children: buttonText }), _jsx(GoToLiveArrow, {})] }));
};
export default GoToLiveButton;
